import * as ko from "knockout"
import inputHtml from './input.html?raw';

export const template = inputHtml

interface IParams {
    observableInput: KnockoutObservable<string>
    state?: () => boolean
    hasHadFocus?: KnockoutObservable<boolean>
    isWaiting?: KnockoutObservable<boolean>
    /** Parent API: true = masked (password). Inverted for toggle-eye (true = revealed). */
    isToggled?: KnockoutObservable<boolean>
    name: string
}

type TInputType = 'text' | 'password'

export class viewModel {

    private readonly isMasked: KnockoutObservable<boolean>
    private readonly observable: KnockoutObservable<string>
    private readonly state: () => boolean | null;
    private readonly hasHadFocus: KnockoutObservable<boolean>
    private readonly isWaiting: KnockoutObservable<boolean>
    private readonly name: string;

    // toggle-eye: true = plain text visible
    readonly isTextMode: KnockoutComputed<boolean>

    constructor(params: IParams) {
        this.observable = params.observableInput
        this.state = params.state ?? (() => null)
        this.hasHadFocus = params.hasHadFocus ?? ko.observable(false)
        this.isWaiting = params.isWaiting ?? ko.observable(false)
        this.isMasked = params.isToggled ?? ko.observable(true)
        this.name = params.name

        this.isTextMode = ko.pureComputed({
            read: () => !this.isMasked(),
            write: (revealed: boolean) => this.isMasked(!revealed),
        })
    }

    private inputType: KnockoutComputed<TInputType> = ko.pureComputed(() => {
        return this.isTextMode() ? 'text' : 'password'
    })

    private onFocusOutHandler() {
        this.hasHadFocus(true)
    }

    private getState() {
        if (this.hasHadFocus()) {
            return this.state()
        }
        return null
    }

}
